import React, { Component } from "react";
import { connect } from "react-redux";
import { getPDF } from "./actions";
import {
    Card,
    CardHeader,
    CardContent,
    Snackbar,
    SnackbarContent,
} from "@material-ui/core";

import { selectPDF } from "./selectors";

class pdfViewer extends Component {
    constructor(props) {
        super(props);
        let reports = false;
        const path = props.location.pathname.split("/");
        if (path[2] === "jobpacks") {
            props.getPDF(path[2], path[8], path[6], path[3], path[4], path[5]);
        } else if (path[2] === "tm_plan") {
            props.getPDF(path[2], path[3], "nothing");
        } else if (path[2] === "method_statement") {
            props.getPDF(path[2], path[8], path[6], path[3], path[4], path[5]);
        } else if (path[2] === "company_policies") {
            props.getPDF(path[2], path[3], "nothing");
        } else if (path[2] === "file_manager") {
            props.getPDF(path[2], path[3], path[4], "nothing");
        } else if (path[2] === "files") {
            props.getPDF(path[2], path[3], "nothing");
         } 
         else reports = true;

        this.state = {
            reportNotRetrieved: reports,
            pdf: false,
            numPages: 0,
            pageNumber: 0,
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.pdf !== this.props.pdf) {
            this.setState({ pdf: this.props.pdf });
        }
    }
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };
    render() {
        let height = window.innerHeight - 230;
        let pdf = this.props.pdf !== false ? this.props.pdf : "";
        return (
            <Card>
                <CardHeader
                    title={`PDF Viewer:${pdf ? pdf.file : "No File Found"}`}
                />

                <CardContent style={{ height: "100%" }}>
                    {pdf && (
                        <iframe
                            title={pdf.file}
                            src={pdf.fileURL}
                            style={{
                                width: "100%",
                                position: "relative",
                                height: `${height}px`,
                                border: 0,
                            }}
                        />
                    )}
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        autoHideDuration={6000}
                        open={this.state.reportNotRetrieved}
                        onClose={() => {
                            this.setState({ reportNotRetrieved: false });
                        }}
                    >
                        <SnackbarContent
                            style={{ backgroundColor: "red", color: "white" }}
                            message="File is having problems being viewed, please contact administrator!"
                        />
                    </Snackbar>
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            pdf: selectPDF(store),
        };
    },
    { getPDF }
)(pdfViewer);
